import React, { useEffect, useState } from "react";
import Select from "../../../ShareElements/Select/Select";
import EmptyStateVector from "../../../../../../Assets/Images/EmptyState.svg";
import MobileTableItem from "../../Shared/MobileTableItem";
import {useHistory} from "react-router-dom";

const StatusTable = (props) => {
  const history = useHistory();
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const translateJPAType = (Type) => {
    if (Type === "Vacancies") {
      return translateText("vacancies");
    } else if (Type === "Projects") {
      return translateText("projects");
    } else {
      return translateText("activities");
    }
  };

  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [Pages, setPages] = useState([1, 2, 3]);
  const [PageInfo, setPageInfo] = useState({});
  const [FilterChipIds] = useState([
    "jpa-filter",
    "location-filter",
    "languages-filter",
    "application-filter",
  ]);
  const [FilterIsOpen, setFilterIsOpen] = useState(false);
  const [SelectedFilter, setSelectedFilter] = useState(
    translateJPAType(props.SelectedJPAType)
  );

  useEffect(() => {
    createPagination();
  }, [props]);

  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const createPagination = () => {
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }
    let Count = Math.ceil(props.TotalElements / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    // getting the actively selected status enum
    let ActiveStatus;
    props.StatusEnums.map((Status) => {
      if (
        document
          .getElementById(Status.id)
          .classList.contains("active-action-btn")
      ) {
        ActiveStatus = Status.enum;
      }
    });

    props.FetchData(Size, NewStart, props.SelectedJPAType, ActiveStatus);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (
      parseInt(document.getElementById("end").innerHTML) === props.TotalElements
    ) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };

  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };

  const setSize = () => {
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const shortenText = (TextString) => {
    if (TextString !== null) {
      if (TextString.length < 20) {
        return TextString;
      } else {
        let Short = TextString.slice(0, 16) + " ...";
        return (
          <React.Fragment>
            {Short}
            <p className="popup-text">{TextString}</p>
          </React.Fragment>
        );
      }
    }
  };

  const removeSortActiveClassNames = () => {
    props.SortIds.map((Sort) => {
      document.getElementById(Sort).classList.remove("active-pointer");
    });
  };

  // this function only handles the className and the main function that contains the API call is
  // called at the end of this function and is on the parent component.
  const sortTable = (SortType, ChipId) => {
    if (SortType === "name") {
      if (
        document.getElementById("jpa-up").classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document.getElementById("jpa-down").classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("jpa-up").classList.add("active-pointer");
      }
    } else if (SortType === "location") {
      if (
        document
          .getElementById("location-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("location-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("location-up").classList.add("active-pointer");
      }
    } else if (SortType === "language") {
      if (
        document
          .getElementById("language-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("language-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("language-up").classList.add("active-pointer");
      }
    } else if (SortType === "application") {
      if (
        document
          .getElementById("application-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("application-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document
          .getElementById("application-up")
          .classList.add("active-pointer");
      }
    }

    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    if (document.getElementById("1-page-btn") !== null) {
      document.getElementById("1-page-btn").click();
    } else {
      props.FetchData(Size, 0, props.SelectedJPAType);
    }

    if (window.innerWidth <= 450) {
      FilterChipIds.map((Chip) => {
        document.getElementById(Chip).classList.remove("mobile-active-filter");
      });
      document.getElementById(ChipId).classList.add("mobile-active-filter");
    }
  };

  const selectJPACode = (Row) => {
    if (props.SelectedJPAType === "Vacancies") {
      return Row.globalPositionCode;
    } else if (props.SelectedJPAType === "Projects") {
      return Row.globalProjectCode;
    } else if (props.SelectedJPAType === "Activities") {
      return Row.globalActivityCode;
    }
  };

  const switchEnum = (Enum) => {
    if (Enum === "ACCEPTED") {
      return "Accepted";
    } else if (Enum === "POPULAR") {
      return "Popular";
    } else if (Enum === "IN_PROGRESS") {
      return "In progress";
    } else if (Enum === "NEW") {
      return "New";
    } else if (Enum === "NOT_STARTED") {
      return "Not started";
    }
  };

  const handleOpenCloseFilter = (Action) => {
    if (Action === "open") {
      setFilterIsOpen(true);
      document
        .getElementById("chat-list-filter-icon")
        .classList.add("icon-rotated");
    } else {
      setFilterIsOpen(false);
      document
        .getElementById("chat-list-filter-icon")
        .classList.remove("icon-rotated");
    }
  };
  const handleSelectFilter = (Id, JPAType) => {
    props.SaveJPAType(JPAType);
    let RowIds = [
      "table-vacancies-filter",
      "table-projects-filter",
      "table-activities-filter",
    ];
    RowIds.map((Item) => {
      if (document.getElementById(Item) !== null) {
        document.getElementById(Item).classList.remove("selected-chat-filter");
      }
    });
    if (document.getElementById(Id) !== null) {
      document.getElementById(Id).classList.add("selected-chat-filter");
    }
    setSelectedFilter(translateJPAType(JPAType));
    setTimeout(() => {
      if (document.getElementById("filters-outline") !== null) {
        document.getElementById("filters-outline").click();
      }
    }, 100);

    // getting the actively selected status enum
    let ActiveStatus;
    props.StatusEnums.map((Status) => {
      if (
        document
          .getElementById(Status.id)
          .classList.contains("active-action-btn")
      ) {
        ActiveStatus = Status.enum;
      }
    });

    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    props.FetchData(Size, 0, JPAType, ActiveStatus);
  };

  const nullToZero = (Count) => {
    if (Count === null) {
      return "0";
    } else {
      return Count;
    }
  };

  const translateStatus = (Status) => {
    if (Status === "Not started") {
      return translateText("not_started");
    } else if (Status === "New") {
      return translateText("new");
    } else if (Status === "In progress") {
      return translateText("in_progress");
    } else if (Status === "Accepted") {
      return translateText("jpa_status_accepted");
    } else if (Status === "Popular") {
      return translateText("popular");
    }
  };

  const navigateToJPADetail = (Type, PositionId) => {
    window.localStorage.setItem("JPAItemId", PositionId);
    switch (Type) {
      case "Vacancies":
        history.push('/JobDetails/')
        break
      case "Projects":
        history.push('/ProjectDetails/')
        break
      default: //Activities
        history.push('/ActivityDetails/')
    }
  }

  return (
    <React.Fragment>
      <div className="data-table status-data-table">
        <section className="table-head">
          <h1>{translateStatus(switchEnum(props.SelectedEnum)) + " state"}</h1>
          <div className="dropdown-wrapper">
            {FilterIsOpen ? (
              <div
                className="outline"
                id="filters-outline"
                onClick={() => handleOpenCloseFilter("close")}
              ></div>
            ) : null}
            <div
              className="dropdown-trigger"
              onClick={() => handleOpenCloseFilter("open")}
            >
              <h1 id="filter-text">{SelectedFilter}</h1>
              <i
                className="feather-chevron-down"
                id="chat-list-filter-icon"
              ></i>
              <React.Fragment>
                <div
                  className={
                    FilterIsOpen ? "chat-list-filter-content" : "hidden"
                  }
                >
                  <section
                    className={
                      props.SelectedJPAType === "Vacancies"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-vacancies-filter"
                    onClick={() =>
                      handleSelectFilter("table-vacancies-filter", "Vacancies")
                    }
                  >
                    {translateText("vacancies")}
                    <i className="feather-check"></i>
                  </section>
                  <section
                    className={
                      props.SelectedJPAType === "Projects"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-projects-filter"
                    onClick={() =>
                      handleSelectFilter("table-projects-filter", "Projects")
                    }
                  >
                    {translateText("projects")}
                    <i className="feather-check"></i>
                  </section>
                  <section
                    className={
                      props.SelectedJPAType === "Activities"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-activities-filter"
                    onClick={() =>
                      handleSelectFilter(
                        "table-activities-filter",
                        "Activities"
                      )
                    }
                  >
                    {translateText("activities")}
                    <i className="feather-check"></i>
                  </section>
                </div>
              </React.Fragment>
            </div>
          </div>
          <span
            className={
              props.TableIsEmpty ? "export-btn disabled-export" : "export-btn"
            }
            onClick={() => props.ToggleExport()}
          >
            <i className="feather-download"></i>
            <p>{translateText("export_data_to_excel")}</p>
          </span>
        </section>
        <div className="table-filters status-table-filters">
          <section
            id="jpa-filter"
            className="table-filter mobile-active-filter column-1"
          >
            <div className="search-filter">
              <i className="feather-search"/>
              <input
                  className="search-filter-input"
                  placeholder={props.SelectedJPAType}
                  value={props.FilterJPA}
                  onChange={(e) => props.setFilterJPA(e.target.value)}
              />
              {!!props.FilterJPA && <i className="feather-x-circle" onClick={() => props.setFilterJPA('')} />}
            </div>
          </section>
          <section
              id="application-filter"
              className="table-filter column-2"
          >
            <div className="search-filter">
              <i className="feather-search"/>
              <input
                  className="search-filter-input"
                  placeholder={translateText("hiring_manager")}
                  value={props.FilterHiringManager}
                  onChange={(e) => props.setFilterHiringManager(e.target.value)}
              />
              {!!props.FilterHiringManager && <i className="feather-x-circle" onClick={() => props.setFilterHiringManager('')} />}
            </div>
          </section>
          <section
            id="application-filter"
            className="table-filter column-other column-4"
            onClick={() => sortTable("application", "application-filter")}
          >
            <p className="filter-name">
              {window.innerWidth <= 450
                ? "Applications"
                : translateText("number_of_applications")}
            </p>
            <span className="filter-pointers">
              <i id="application-up" className="feather-chevron-up"></i>
              <i id="application-down" className="feather-chevron-down"></i>
            </span>
          </section>
          <section
            id="location-filter"
            className="table-filter column-other center"
            onClick={() => sortTable("location", "location-filter")}
          >
            <p className="filter-name">{translateText("location")}</p>
            <span className="filter-pointers">
              <i id="location-up" className="feather-chevron-up"></i>
              <i id="location-down" className="feather-chevron-down"></i>
            </span>
          </section>
          <section
            id="languages-filter"
            className="table-filter column-other center"
            onClick={() => sortTable("language", "languages-filter")}
          >
            <p className="filter-name">{translateText("language")}</p>
            <span className="filter-pointers">
              <i id="language-up" className="feather-chevron-up"></i>
              <i id="language-down" className="feather-chevron-down"></i>
            </span>
          </section>
        </div>
        {props.TableIsEmpty ? (
          <div className="empty-state">
            <img alt="" src={EmptyStateVector} />
            <p>there is no apllication in this stage</p>
          </div>
        ) : (
          <main className="table-content">
            {props.Data.length === 0 ? null : (
              <React.Fragment>
                {props.Data.map((Row, i) => (
                  <>
                    <div
                        className="table-row is-desktop"
                        key={i}
                    >
                      <section className="table-filter column-1">
                        <span className="info-grid">
                          <p
                            className="bg-text"
                          >
                            <span onClick={() => navigateToJPADetail(props.SelectedJPAType, Row.id)}>
                              {shortenText(Row.title)}
                            </span>
                          </p>
                          <p className="sm-text">
                            {"(" + selectJPACode(Row) + ")"}
                          </p>
                        </span>
                      </section>
                      <section className="table-text column-2">
                        {shortenText(`${Row.hrFirstName} ${Row.hrLastName}`)}
                      </section>
                      <section className="table-text centered-text column-other column-4">
                        {nullToZero(Row.count)}
                      </section>
                      <section className="table-text column-other column-3">
                        {shortenText(Row.workCity)}
                      </section>
                      <section className="table-text column-other column-3">
                        {shortenText(Row.languages)}
                      </section>
                    </div>
                    <MobileTableItem
                      RowItem={Row}
                      SelectedJPAType={props.SelectedJPAType}
                      IsStatus
                      NavigateToJPADetail={() => navigateToJPADetail(props.SelectedJPAType, Row.id)}
                    />
                  </>
                ))}
                <div className="info-footer" id="info-footer">
                  <div className="pagenumber-summary">
                    {translateText("showing")}
                    <p id="start">1</p>
                    {translateText("to")}
                    <p id="end">5</p>
                    {translateText("of") + " "}
                    {props.TotalElements + " "}
                    {translateText("items")}.
                  </div>
                  <section className="pagination-holder">
                    <button
                      onClick={() => requestPrevPage()}
                      id="prev-page"
                      className="page-btn page-btn-disabled"
                    >
                      <i className="feather-chevron-left"></i>
                    </button>
                    <React.Fragment>
                      {Pages.length < 6 ? (
                        <React.Fragment>
                          {Pages.map((Page) => (
                            <React.Fragment>
                              {Page === 1 ? (
                                <button
                                  key={Page}
                                  onClick={() => requestPageNumber(Page)}
                                  className="page-btn active-page"
                                  id={Page + "-page-btn"}
                                >
                                  {Page}
                                </button>
                              ) : (
                                <button
                                  key={Page}
                                  onClick={() => requestPageNumber(Page)}
                                  className="page-btn"
                                  id={Page + "-page-btn"}
                                >
                                  {Page}
                                </button>
                              )}
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <button
                            onClick={() => requestPageNumber(1)}
                            className="page-btn active-page"
                            id={1 + "-page-btn"}
                          >
                            {1}
                          </button>
                          {PageInfo.FirstDotsShown ? <p>...</p> : null}
                          <button
                            onClick={() =>
                              requestPageNumber(
                                parseInt(PageInfo.MiddlePage - 1)
                              )
                            }
                            className="page-btn"
                            id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                          >
                            {parseInt(PageInfo.MiddlePage - 1)}
                          </button>
                          {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                            <button
                              onClick={() =>
                                requestPageNumber(PageInfo.MiddlePage)
                              }
                              className="page-btn"
                              id={PageInfo.MiddlePage + "-page-btn"}
                            >
                              {PageInfo.MiddlePage}
                            </button>
                          )}
                          {parseInt(PageInfo.MiddlePage + 1) >=
                          PageInfo.LastPage ? null : (
                            <button
                              onClick={() =>
                                requestPageNumber(
                                  parseInt(PageInfo.MiddlePage + 1)
                                )
                              }
                              className="page-btn "
                              id={
                                parseInt(PageInfo.MiddlePage + 1) + "-page-btn"
                              }
                            >
                              {parseInt(PageInfo.MiddlePage + 1)}
                            </button>
                          )}
                          {!PageInfo.LastDotsShown ? <p>...</p> : null}
                          <button
                            onClick={() => requestPageNumber(PageInfo.LastPage)}
                            className="page-btn"
                            id={PageInfo.LastPage + "-page-btn"}
                          >
                            {PageInfo.LastPage}
                          </button>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                    <button
                      onClick={() => requestNextPage()}
                      id="next-page"
                      className="page-btn"
                    >
                      <i className="feather-chevron-right"></i>
                    </button>
                  </section>
                  <div className="row-count-select">
                    <p className="row-info">{translateText("rows_per_page")}</p>
                    <Select
                      Initial={"5"}
                      Options={SizeOptions}
                      PreSelectedId="5"
                      IsWithId
                      Id={"row-per-page"}
                      ChangeHandler={() =>
                        setTimeout(() => {
                          setSize();
                        }, 100)
                      }
                      ValidationError=""
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </main>
        )}
      </div>
    </React.Fragment>
  );
};

export default StatusTable;
